// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type UpdateProjectCoverImageMutationVariables = Types.Exact<{
  input: Types.ProjectInput;
}>;


export type UpdateProjectCoverImageMutation = { __typename?: 'Mutation', saveProject: { __typename?: 'SaveProjectResult', project:
      | { __typename?: 'StandaloneProject', id: string, coverImage?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined }
      | { __typename?: 'Region', id: string, coverImage?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined }
      | { __typename?: 'Market', id: string, coverImage?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined }
      | { __typename?: 'Community', id: string, coverImage?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined }
      | { __typename?: 'Subdivision', id: string, coverImage?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined }
      | { __typename?: 'Lot', id: string, coverImage?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined }
      | { __typename?: 'Structure', id: string, coverImage?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined }
      | { __typename?: 'Unit', id: string, coverImage?: { __typename?: 'Asset', id: string, downloadUrl: string } | null | undefined }
     } };


export const UpdateProjectCoverImageDocument = gql`
    mutation UpdateProjectCoverImage($input: ProjectInput!) {
  saveProject(input: $input) {
    project {
      id
      coverImage {
        id
        downloadUrl
      }
    }
  }
}
    `;

/**
 * __useUpdateProjectCoverImageMutation__
 *
 * To run a mutation, you first call `useUpdateProjectCoverImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProjectCoverImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProjectCoverImageMutation, { data, loading, error }] = useUpdateProjectCoverImageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProjectCoverImageMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateProjectCoverImageMutation, UpdateProjectCoverImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateProjectCoverImageMutation, UpdateProjectCoverImageMutationVariables>(UpdateProjectCoverImageDocument, options);
      }
export type UpdateProjectCoverImageMutationHookResult = ReturnType<typeof useUpdateProjectCoverImageMutation>;
export type UpdateProjectCoverImageMutationResult = ApolloReactCommon.MutationResult<UpdateProjectCoverImageMutation>;